/**
 * Campaign Trigger Type - WHO can initiate a claim
 *
 * This defines the authentication/authorization context for claiming rewards.
 * NOT to be confused with TriggerSourceType which defines HOW to claim (QR, NFC, etc.)
 *
 * Relationship:
 * - campaign.trigger.triggerType → WHO can claim (CLAIM_BY_USER, CLAIM_BY_BUSINESS, CLAIM_BY_SYSTEM)
 * - campaign.triggerSources[].type → HOW to claim (QR_CODE, NFC_TAG, GPS_GEOFENCE, etc.)
 *
 * Example Flow:
 * 1. Campaign has triggerType=CLAIM_BY_USER (users initiate claims)
 * 2. Campaign has triggerSources with type=QR_CODE (via QR scan)
 * 3. User scans QR code → App calls claimCampaign with triggerSourceId
 *
 * @see TriggerSourceType for HOW claims are triggered
 * @see CampaignClaimRequestDTO for the claim payload structure
 */
export var CampaignTriggerType;
(function (CampaignTriggerType) {
    /**
     * User-initiated claims. The end user triggers the claim action.
     * App determines HOW via campaign.triggerSources[].type:
     * - QR_CODE: Open camera/scanner
     * - NFC_TAG: Activate NFC reader
     * - GPS_GEOFENCE: Send user location
     * - TRANSACTION: Triggered by purchase
     */
    CampaignTriggerType["CLAIM_BY_USER"] = "CLAIM_BY_USER";
    /**
     * System/server-initiated claims. Automated processes trigger claims.
     * Use cases: webhooks, scheduled jobs, backend integrations.
     * Requires tenant API key authentication.
     */
    CampaignTriggerType["CLAIM_BY_SYSTEM"] = "CLAIM_BY_SYSTEM";
    /**
     * Business-initiated claims. A business claims on behalf of users.
     * Use cases: POS systems, staff-assisted redemptions, kiosks.
     * Requires business authentication + user identifier.
     */
    CampaignTriggerType["CLAIM_BY_BUSINESS"] = "CLAIM_BY_BUSINESS";
})(CampaignTriggerType || (CampaignTriggerType = {}));
//# sourceMappingURL=campaignTriggerType.enum.js.map